import type { ColumnType } from 'ant-design-vue/es/table'
import { Component, h, VNodeChild } from 'vue'


export class ColumnDefinition<TModel> {

    public slotName?: string;
    public align?: ColumnType<TModel>['align'];
    public fixed?: ColumnType<TModel>['fixed'];
    public width?: ColumnType<TModel>['width'];
    public clickable?: boolean;
    public cellRenderer?: (record: TModel, index?: number) => VNodeChild;

    constructor(
        public modelProperty: string | undefined,
        public columnId: string | string[] | undefined,
        public columnHeader: string,
        public cellComponent?: Component,
        // optional props to pass to cellComponent
        public cellProps?: Record<string, any>
    ) { }

    toColumn(): ColumnType<TModel> {
        const key = this.modelProperty;
        const col: ColumnType<TModel> = {
            title: this.columnHeader,
            dataIndex: this.columnId,
            key,
            // apply optional layout props so ant-table will use them
            ...(this.align ? { align: this.align } : {}),
            ...(this.fixed !== undefined ? { fixed: this.fixed } : {}),
            ...(this.width !== undefined ? { width: this.width } : {})
        } as ColumnType<TModel>;

        // prefer rendering a provided component, passing record/index via props
        if (this.cellComponent) {
            const comp = this.cellComponent;
            col.customRender = (opt: {
                value: any
                text: any
                record: TModel
                index: number
                renderIndex: number
                column: ColumnType<TModel>
            }) => {
                const props = {
                    ...(this.cellProps || {}),
                    record: opt.record,
                    index: opt.index,
                    value: opt.value,
                    text: opt.text
                };
                return h(comp as any, props);
            };
        } else if (this.cellRenderer) {
            col.customRender = (opt: {
                value: any
                text: any
                record: TModel
                index: number
                renderIndex: number
                column: ColumnType<TModel>
            }) => {
                return this.cellRenderer?.(opt.record, opt.index)
            }
        }

        return col
    }
}